/**
 * A point moved away from (or toward) a fixed point by `scale`, for a glyph
 * that grows its outline by moving its corners rather than scaling the
 * drawing, so the stroke keeps its weight.
 */export default function scaledAbout(point,about,scale){return{x:about.x+(point.x-about.x)*scale,y:about.y+(point.y-about.y)*scale};}